import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { Additionalflat } from './additionalflat.model';
import { AdditionalflatPopupService } from './additionalflat-popup.service';
import { AdditionalflatService } from './additionalflat.service';

@Component({
    selector: 'jhi-additionalflat-delete-dialog',
    templateUrl: './additionalflat-delete-dialog.component.html'
})
export class AdditionalflatDeleteDialogComponent {

    additionalflat: Additionalflat;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private additionalflatService: AdditionalflatService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['additionalflat']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.additionalflatService.delete(id).subscribe((response) => {
            this.eventManager.broadcast({
                name: 'additionalflatListModification',
                content: 'Deleted an additionalflat'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-additionalflat-delete-popup',
    template: ''
})
export class AdditionalflatDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private additionalflatPopupService: AdditionalflatPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            this.modalRef = this.additionalflatPopupService
                .open(AdditionalflatDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/additionalflat/additionalflat-delete-dialog.component.ts